module.exports = __webpack_public_path__ + "static/media/avatar.b5dfbe02.png";